import { render, staticRenderFns } from "./EditTemplateDocument.vue?vue&type=template&id=12be0ffc&"
import script from "./EditTemplateDocument.vue?vue&type=script&lang=ts&"
export * from "./EditTemplateDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports